export const LOGIN_STAGES = {
  email: 1,
  code: 2,
};
